import { type ComponentProps, useRef } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form as FactorialForm } from 'factorial-form'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import permissionGroups from 'modules/permissions/store/collections/permissionGroups'

type ModalProps = ComponentProps<typeof Modal>

class NewGroupForm extends FactorialForm {
  constructor(values: {}) {
    super(values, {
      name: 'string',
    })
  }
}

const NewGroup = ({ onClose }: Pick<ModalProps, 'onClose'>) => {
  const newGroupForm = useRef(new NewGroupForm({ name: '' })).current

  const createPermissionGroup = async (closePortal: ClosePortalFn) => {
    await newGroupForm.create(permissionGroups)
    closePortal()
  }

  const { running: runningCreation, performAction: onSubmit } = useAsyncAction(
    createPermissionGroup,
    {
      successFlash: true,
      errorFlash: true,
    }
  )

  return (
    <Modal
      onClose={onClose}
      onSubmit={onSubmit}
      illustration="user-interaction-review_chart"
      title={i18n.t('settings.permissions.new.title')}
      description={i18n.t('settings.permissions.new.description')}
      footer={
        <Button disabled={!newGroupForm.get('name').value || runningCreation} submit>
          {i18n.t('common.submit')}
        </Button>
      }
    >
      {runningCreation ? (
        <Loading />
      ) : (
        <Text label={i18n.t('settings.permissions.new.name')} field={newGroupForm.get('name')} />
      )}
    </Modal>
  )
}

export default observer(NewGroup)
